import React from "react";
import { NavLink as RouterNavLink, useLocation } from "react-router-dom";
import Can from "../../auth/Can";
import roles from "../../auth/roles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    UncontrolledTooltip
} from "reactstrap";

const CentraleNav = ({ path }) => {
    let location = useLocation();
    const [color, setColor] = React.useState(color);

    React.useEffect(() => {
        const newColor =
            window.location.pathname.includes(path)
                ? "primary"
                : "secondary";
        //console.log(window.location.pathname);
        setColor(newColor);
    }, [location]);

    return (
        <Can
            roles={[roles.ADMIN, roles.CENTRALE]}
            yes={() => (
                <UncontrolledDropdown className="ml-1 mt-1">
                    <DropdownToggle color={color} id="ticketNavBtn" caret>
                        <FontAwesomeIcon icon="ticket-alt" /><span className="d-none d-xl-block">Ticket</span>
                    </DropdownToggle>
                    <UncontrolledTooltip placement="auto" popperClassName="tooltip-primary" target="ticketNavBtn">
                        Ticket
                    </UncontrolledTooltip>
                    <DropdownMenu>
                        <DropdownItem
                            tag={RouterNavLink}
                            to={`${path}/add-ticket`}
                            className="dropdown-profile"
                            activeClassName="router-link-exact-active-nav"
                        >
                            <FontAwesomeIcon icon="ticket-alt" className="mr-1" /> Nuovo Ticket
                        </DropdownItem>

                        <DropdownItem
                            tag={RouterNavLink}
                            to={`${path}/tickets`}
                            className="dropdown-profile"
                            activeClassName="router-link-exact-active-nav"
                        >
                            <FontAwesomeIcon icon="list" className="mr-1" /> Elenco Ticket
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            )}
            no={() => null}
        />
    );
};

export default CentraleNav;
